import React, { useEffect, useRef } from "react";
import "../css/donationform.css";
import { QRCodeCanvas } from "qrcode.react";
import Modal from "react-modal"; // Install react-modal or use your own modal component

import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import translations from "../resources/translations";
import donationDetail from "../utility/donationDetail.js";
import { assets } from "../assets/assets.js";
import ReCAPTCHA from "react-google-recaptcha";

const DonateForm = ({ setLanguage }) => {
  // to keep form data
  const currentLanguage = translations[setLanguage] || translations["mr"]; // Default to 'mr' if language is not found
  const [paymentMethod, setPaymentMethod] = useState("qrCode"); // Default to "qrCode"
  // preview image
  const [image, setImage] = useState(null);
  const url = process.env.REACT_APP_BASE_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaStatus, setCaptchaStaus] = useState(null);
  const recaptchaRef = useRef(null);  // Add this ref

  const CaptchaSiteKey = process.env.REACT_APP_CAPTCHA_SITEKEY;

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
    setCaptchaStaus(null); // Reset status on new verification
  };


  const [formData, setFormData] = useState({
    name: "",
    gotra: "",
    email: "",
    phNumber: "",
    pincode: "",
    state: "",
    city: "",
    address: "",
    donationType: "",
    amount: "",
    stateIos: "",
    subDonationType: "",
    denagi: "",
    utr: "",
    imagePayment: null,
    paymentMethod: "",
  });

  const [isDisable, setIsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedSubDonationType, setSelectedSubDonationType] = useState("");
  const [subDonationTypes, setSubDonationTypes] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState("");
  const API_KEY = "TTdJcU1nN0VROXFSd0xxcGhuRXo4eU9Ec0l1OXQ4S2JzdzZlMkNnQg==";
  const [showQRCode, setShowQRCode] = useState(false);
  const upiId = "svsptakli@sbi"; // Replace with your UPI ID

  // Handle field value changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount") {
      // For the 'amount' field,
      let updatedValue = value.replace(/[^0-9]/g, "");
      setFormData({
        ...formData,
        [name]: updatedValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // QR Code generation
  const handleGenerateQRCode = () => {
    if (!formData.amount || parseInt(formData.amount) < 101) {
      setShowQRCode(false); // Ensure QR code is hidden
      return;
    }

    const qrData = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      formData.name
    )}&am=${formData.amount}&cu=INR`;
    setQrCodeValue(qrData);
    setShowQRCode(true);
  };

  // Submit form data to backend through API
  const handleOnSubmit = async (e) => {
    e.preventDefault();


    // Checking If The code is present or not ?
     if (!captchaToken) {
      setErrors(prev => ({...prev, captchaToken: "Please complete the CAPTCHA"}));
      return;
    }

    const formDataSend = new FormData(); // Create a FormData object
    formDataSend.append("title", formData.title); // Append other fields
    formDataSend.append("name", formData.name);
    formDataSend.append("gotra", formData.gotra);
    formDataSend.append("email", formData.email);
    formDataSend.append("phNumber", formData.phNumber);
    formDataSend.append("pincode", formData.pincode);
    formDataSend.append("state", formData.state);
    formDataSend.append("city", formData.city);
    formDataSend.append("address", formData.address);
    formDataSend.append("donationType", formData.donationType);
    formDataSend.append("subDonationType", formData.subDonationType);
    formDataSend.append("denagi", formData.denagi);
    formDataSend.append("amount", formData.amount);
    formDataSend.append("utr", formData.utr);
    formDataSend.append("paymentMethod", paymentMethod);

    // Append the image file
    if (image) {
      formDataSend.append("imagePayment", image);
    }

    // console.log(formDataSend);
    formDataSend.append("donationFor", formData.donationType);
    formDataSend.append("captchaToken", captchaToken);

    if (validation()) {
      try {
        const response = await axios.post(
          `${url}/api/donations/add`,

          formDataSend
        );

        setFormData({
          name: "",
          gotra: "",
          email: "",
          phNumber: "",
          pincode: "",
          state: "",
          city: "",
          address: "",
          donationType: "",
          amount: "",
          stateIos: "",
          subDonationType: "",
          denagi: "",
          utr: "",
          imagePayment: image,
          paymentMethod: paymentMethod,
        });
        setImage(null);
        setIsSubmitted(true);
        // reset captcha
        setCaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();  // Reset CAPTCHA
        }
        setIsModalOpen(true);

        setErrors({});
        setIsChecked(false); // Reset checkbox
        setShowQRCode(true); // Show QR code after successful submission
      } catch (error) {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();  // Reset on error
        }
        setCaptchaToken(null);
        const errorMessage = error.response?.data?.message || "Donation submission failed. Please try again.";
        toast.error(errorMessage);
        if (process.env.NODE_ENV === 'development') {
          console.error("Error submitting donation:", error.response?.data || error.message);
        }
      }
    }
  };

  // Handle state change
  const handleStateChange = (e) => {
    const selectedStateCode = e.target.value;
    const selectedState = stateList.find(
      (state) => state.iso2 === selectedStateCode
    );
    if (selectedState) {
      setFormData({
        ...formData,
        stateIos: selectedStateCode,
        state: selectedState.name,
      });
    }
  };
  //  handle handleDonationFor
  const handleDonationFor = (e) => {
    const selectedDonationType = e.target.value;
    setSelectedSubDonationType(selectedDonationType);
    setSubDonationTypes(
      Object.keys(donationDetail[selectedDonationType] || {})
    );
    setFormData({
      ...formData,
      donationType: selectedDonationType,
    });
  };

  // handle sub Donation
  const handleSubDonation = (e) => {
    const subDonationValue = e.target.value;
    const donationAmount =
      donationDetail[formData.donationType]?.[subDonationValue] || "";

    setFormData({
      ...formData,
      subDonationType: subDonationValue,
      amount: donationAmount, // Update amount based on selected sub-donation type
    });

    if (donationAmount) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  };

  //   validation rules
  const validation = () => {
    let newErrors = {};
    // reg expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    const pincodeRegex = /^[0-9]{6}$/;

    // name
    if (!formData.name) {
      newErrors.name = "कृपया आपले नाव प्रविष्ट करा";
    }

    // email
    if (!formData.email) {
      newErrors.email = "कृपया  ईमेल प्रविष्ट करा";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email =
        "कृपया वैध ईमेल आयडी प्रविष्ट करा. उदाहरण: sunil@gmail.com";
    }

    //  Phone Number
    if (!formData.phNumber)
      newErrors.phNumber = "कृपया  फोन नंबर प्रविष्ट करा.";
    else if (!phoneRegex.test(formData.phNumber))
      newErrors.phNumber = "कृपया १० अंकी वैध मोबाईल नंबर प्रविष्ट करा. ";

    //  pincode

    if (!formData.pincode) newErrors.pincode = "कृपया  पिनकोड  प्रविष्ट करा.";
    else if (!pincodeRegex.test(formData.pincode))
      newErrors.pincode = "कृपया ६ अंकी वैध पिनकोड प्रविष्ट करा.";

    if (!formData.state) {
      newErrors.state = "कृपया आपल्या राज्याची निवड करा. ";
    }
    if (!formData.city) {
      newErrors.city = "कृपया आपल्या शहराची  निवड करा किंवा Others.";
    }
    if (!formData.address) {
      newErrors.address = "कृपया संपूर्ण पत्ता प्रविष्ट करा.";
    }

    // donation type
    if (!formData.donationType) {
      newErrors.donationType = "कृपया देणगी प्रकार निवडा ";
    }

    // set rules for amount
    if (!formData.amount) {
      newErrors.amount = "कृपया रक्कम प्रविष्ट करा.";
    } else if (!/^\d+$/.test(formData.amount)) {
      // Regular expression to allow only digits (no signs, special characters, or alphabets)
      newErrors.amount =
        "कृपया कोणतेही विशेष चिन्ह किंवा अक्षरांशिवाय वैध रक्कम प्रविष्ट करा.";
    } else if (parseInt(formData.amount) <= 100) {
      newErrors.amount = "रक्कम १०० पेक्षा जास्त असावी.";
    } else if (parseInt(formData.amount) < 0) {
      newErrors.amount =
        "रक्कम नकारात्मक(-100) असू शकत नाही. कृपया सकारात्मक रक्कम प्रविष्ट करा.";
    }

    // utr validation
    if (!formData.utr) {
      newErrors.utr = "कृपया Transaction नंबर लिहा.";
    } else if (formData.utr.length > 26) {
      newErrors.utr = "Transaction नंबर 26 पेक्षा कमी अक्षरांचा असावा.";
    }

    if (!image) {
      newErrors.imagePayment = "कृपया पेमेंटची प्रतिमा अपलोड करा.";
    }

    // Checkbox validation
    if (!isChecked) {
      newErrors.terms = "तुम्हाला अटी आणि शर्ती मान्य कराव्या लागतील.";
    }

    if (!captchaToken) {
      newErrors.captchaToken = "Captch is required";
    }
    //  set errors to state
    setErrors(newErrors);

    // check for  error
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    getAllState();
  }, [formData.donationType, formData.amount, subDonationTypes, formData]);

  useEffect(() => {
    if (formData.state) {
      getAllCityByState();
    } else {
      setCityList([]);
    }
  }, [formData.state]);

  return (
    <form onSubmit={handleOnSubmit} className="form-container">
      <div className="form-col-container">
        {/* First Column */}
        <div className="form-first-col">
          <div className="form-control">
            <label htmlFor="name">
              {" "}
              {currentLanguage.donationForm?.name}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <small>{errors.name}</small>}
          </div>
          <div className="form-control">
            <label htmlFor="gotra">{currentLanguage.donationForm?.gotra}</label>
            <input
              type="text"
              name="gotra"
              id="gotra"
              value={formData.gotra}
              onChange={handleChange}
            />
            {/* {errors.gotra && <small>{errors.gotra}</small>} */}
          </div>
          <div className="form-control">
            <label htmlFor="email">
              {currentLanguage.donationForm?.email}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <small>{errors.email}</small>}
          </div>

          <div className="form-control">
            <label htmlFor="phNumber">
              {currentLanguage.donationForm?.phNumber}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="text"
              name="phNumber"
              maxlength="10"
              id="phNumber"
              value={formData.phNumber}
              onChange={handleChange}
              onInput={(e) => {
                // Allow only digits (numbers)
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
            />
            {errors.phNumber && <small>{errors.phNumber}</small>}
          </div>
          <div className="form-control">
            <label htmlFor="pincode">
              {currentLanguage.donationForm?.pincode}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="text"
              maxlength="6"
              name="pincode"
              id="pincode"
              value={formData.pincode}
              onChange={handleChange}
              onInput={(e) => {
                // Allow only digits (numbers) and restrict to 6 characters
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 6);
              }}
            />
            {errors.pincode && <small>{errors.pincode} </small>}
          </div>

          <div className="form-control">
            <label htmlFor="state">
              {currentLanguage.donationForm?.state}{" "}
              <span className="red-star">*</span>
            </label>
            <select
              name="state"
              id="state"
              value={formData.stateIos}
              onChange={handleStateChange}
            >
              <option value="">
                -- {currentLanguage.donationForm?.state} निवडा --
              </option>
              {stateList.map((state) => {
                return (
                  <option key={state.iso2} value={state.iso2}>
                    {state.name}
                  </option>
                );
              })}
            </select>
            {errors.state && <small>{errors.state}</small>}
          </div>
          <div className="form-control">
            <label htmlFor="city">
              {currentLanguage.donationForm?.city}
              <span className="red-star">*</span>
            </label>
            <select
              name="city"
              id="city"
              value={formData.city}
              onChange={handleChange}
            >
              <option value="">
                -- {currentLanguage.donationForm?.city} निवडा --
              </option>

              {cityList.map((item) => {
                return (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                );
              })}
              <option value="other">Others</option>
            </select>
            {errors.city && <small>{errors.city}</small>}
          </div>

          <div className="form-control">
            <label htmlFor="address">
              {currentLanguage.donationForm?.address}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="text"
              name="address"
              id="address"
              value={formData.address}
              onChange={handleChange}
            />
            {errors.address && <small>{errors.address}</small>}
          </div>
          {/* Donation Type */}
          <div className="form-control">
            <label htmlFor="donationType">
              {currentLanguage.donationForm?.donationType}{" "}
              <span className="red-star">*</span>
            </label>
            <select
              name="donationType"
              id="donationType"
              value={formData.donationType}
              onChange={handleDonationFor}
            >
              <option value="">
                -- {currentLanguage.donationForm?.["donationType for"]} --
              </option>
              {Object.keys(donationDetail).map((key) => (
                <option key={key} value={key}>
                  {key}
                </option>
              ))}
            </select>
            {errors.donationType && <small>{errors.donationType}</small>}
          </div>
          {/* start here  */}
          {/* Sub Items */}
          <div className="form-control">
            <label htmlFor="subDonationType">
              {currentLanguage.donationForm?.["Sub Donation Type"]}{" "}
              <span className="red-star">*</span>
            </label>
            <select
              name="subDonationType"
              id="subDonationType"
              value={formData.subDonationType}
              onChange={handleSubDonation}
            >
              <option value="">
                --- {currentLanguage.donationForm?.["Sub Donation Type"]} ---
              </option>
              {subDonationTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            {errors.subDonationType && <small>{errors.subDonationType}</small>}
          </div>

          {/* end here */}

          <div className="form-control">
            <label htmlFor="amount">
              {currentLanguage.donationForm?.amount}{" "}
              <span className="red-star">*</span>
            </label>
            <input
              type="text"
              name="amount"
              id="amount"
              placeholder="&#8377;101"
              value={formData.amount}
              onChange={handleChange}
              onClick={handleGenerateQRCode}
              disabled={isDisable}
            />
            {errors.amount && <small>{errors.amount}</small>}
          </div>
          <div className="form-control">
            <label htmlFor="denagi">देणगी प्रयोजन </label>
            <input
              type="text"
              name="denagi"
              id="denagi"
              value={formData.denagi}
              onChange={handleChange}
            />
          </div>

          {/* control rdio here  */}
          <div className="form-control">
            <label>
              पेमेंट पद्धत निवडा: <span className="red-star">*</span>
            </label>
            {errors.paymentMethod && <small>{errors.paymentMethod}</small>}
            <div className="payment-radio">
              <label>QR कोड </label>

              <input
                type="radio"
                name="paymentMethod"
                value="qrCode"
                checked={paymentMethod === "qrCode"}
                onChange={() => setPaymentMethod("qrCode")}
              />
            </div>

            <div className="payment-radio">
              <label>खाते तपशील </label>

              <input
                type="radio"
                name="paymentMethod"
                value="accountDetails"
                checked={paymentMethod === "accountDetails"}
                onChange={() => setPaymentMethod("accountDetails")}
              />
            </div>
          </div>

          {/* redering logic here  */}
          {paymentMethod === "qrCode" && (
            <div className="account-container">
              {/* QR Code Generation Section */}
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <h2>स्कॅन करा</h2>
                {formData.amount && parseInt(formData.amount) >= 101 ? (
                  <>
                    <QRCodeCanvas
                      value={`upi://pay?pa=${upiId}&pn=Donation&am=${formData.amount}&cu=INR`}
                      size={156}
                    />
                    <p>देणगी ₹{formData.amount}</p>
                  </>
                ) : (
                  isSubmitted && (
                    <p style={{ color: "red" }}>
                      ऑनलाईन देणगीची किमान मर्यादा रुपये १०१ आहे.{" "}
                    </p>
                  )
                )}
              </div>
            </div>
          )}

          {paymentMethod === "accountDetails" && (
            <div className="account-container">
              <tbody>
                <tr>
                  <td>
                    <strong>Account Holder Name : </strong>
                  </td>
                  <td>SACCHIDANANDA VED SWADHYAY PRATISHTHAN</td>
                </tr>
                <tr>
                  <td>
                    <strong>Account Number : </strong>
                  </td>
                  <td> 30573310620 </td>
                </tr>
                <tr>
                  <td>
                    <strong>Bank Name : </strong>
                  </td>
                  <td>State Bank Of India</td>
                </tr>
                <tr>
                  <td>
                    <strong>Branch Name : </strong>
                  </td>
                  <td>PURNA BRANCH </td>
                </tr>
                <tr>
                  <td>
                    <strong>IFSC Code : </strong>
                  </td>
                  <td>SBIN0004561</td>
                </tr>
                <tr>
                  <td>
                    <strong>Transfer Information</strong>
                  </td>
                  <td>या माहितीच्या आधारे ट्रान्सफर करू शकता.</td>
                </tr>
              </tbody>
              {/* Add other account details if necessary */}
            </div>
          )}

          <div className="account-container">
            <div className="form-control">
              <label htmlFor="denagi">
                Transaction संदर्भ/क्रमांक <span className="red-star">*</span>
              </label>
              <input
                type="text"
                maxlength="26"
                name="utr"
                id="utr"
                value={formData.utr}
                onChange={handleChange}
                onInput={(e) => {
                  // Allow only alphanumeric characters (A-Z, a-z, 0-9) and restrict to 26 characters
                  e.target.value = e.target.value
                    .replace(/[^a-zA-Z0-9]/g, "")
                    .slice(0, 26);
                }}
              />
              {errors.utr && <small>{errors.utr}</small>}
            </div>

            {/* image */}

            <div className="add-image-upload flex-col form-control">
              <h6>
                प्रतिमा अपलोड करा <span className="red-star">*</span>
              </h6>
              <label htmlFor="image">
                <img
                  src={image ? URL.createObjectURL(image) : assets.upload_area}
                  alt="Preview"
                />
              </label>
              {errors.imagePayment && <small>{errors.imagePayment}</small>}
              <input
                onChange={(e) => setImage(e.target.files[0])}
                type="file"
                id="image"
                name="imagePayment"
                hidden
              />
            </div>
          </div>

          {/* privacy policy */}
          <div className="checkbox-form-control">
            <input
              type="checkbox"
              id="terms"
              checked={isChecked}
              onChange={() => {
                setIsChecked(!isChecked);
                setErrors((prevErrors) => ({ ...prevErrors, terms: "" }));
              }}
            />
            <label htmlFor="terms">
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Terms and Conditions
              </a>
            </label>
            {errors.terms && <small>{errors.terms}</small>}
          </div>

          {/* captcha code  */}

          <div className="checkbox-form-control">
            <ReCAPTCHA ref={recaptchaRef} sitekey={CaptchaSiteKey} onExpired={() => setCaptchaToken(null)} onChange={handleCaptcha} />

            {errors.captchaToken && <small>{errors.captchaToken}</small>}
          </div>

          <div className="form-btn">
            <button type="submit" className="btn-submit">
              {currentLanguage.donationForm?.submit}
            </button>

            <button type="reset" className="btn-reset" onClick={handleReset}>
              {currentLanguage.donationForm?.reset}
            </button>
          </div>
        </div>
      </div>
      <div>
        {/* Your Form Components Here */}

        {/* Modal for the Success Message */}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          contentLabel="Donation Success"
          ariaHideApp={false} // Disable app hiding if not required
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            },
          }}
        >
          <h2>आपल्या देणगीरूपी सहकार्याबद्दल आम्ही आपले आभारी आहोत!</h2>
          <p>
            काही तांत्रिक कारणामुळे आपल्या देणगीची पावती २-३ दिवसात आपणास आपण
            दिलेल्या ईमेल व मोबाईल वर पाठवण्यात येईल. तसदीबद्दल क्षमस्व.
          </p>
          <button onClick={() => setIsModalOpen(false)}>Close</button>
        </Modal>
      </div>
    </form>
  );

  function handleReset() {
    setErrors({});
    setFormData({});
    setImage(null);
  }

  // fetch all state data
  async function getAllState() {
    try {
      const result = await axios.get(
        "https://api.countrystatecity.in/v1/countries/IN/states",
        {
          headers: {
            "X-CSCAPI-KEY": API_KEY,
          },
        }
      );
      setStateList(result.data);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching states:", error.message);
      }
    }
  }

  // fetch city based on state
  async function getAllCityByState() {
    try {
      const result = await axios.get(
        `https://api.countrystatecity.in/v1/countries/IN/states/${formData.stateIos}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY": API_KEY,
          },
        }
      );
      setCityList(result.data);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching Cities:", error.message);
      }
    }
  }
};

export default DonateForm;
